import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        publicKey: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCNOSfIXSfMnYFkzs5MfKa8pr8lW1/Lpxhvidbn8VV0h5XKlhQUJaQSiw9Vz3wq2OLQ1G+QokqGE7ZQ0B+nkqzPn2MELx5fC3t7RqydTQJ+B1l1xDGXFa+1TjUeN2iYwIFG4YoMaO3dvoHFyukq56yDYt46Fw+yEkNbzv9YnKRR8QIDAQAB',
        dingTalkUrl: "https://oapi.dingtalk.com/connect/oauth2",
        appId: "dingoabxkclsz2ak2skdsm",
        redirectUri: window.location.protocol + "//" + window.location.host + "/dingTalk",
    },
    getters: {
        getGoto(state) {
            return encodeURIComponent(state.dingTalkUrl + '/sns_authorize?appid=' + state.appId + '&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=' + state.redirectUri);
        },
        getAuthorizeUrl(state, getters) {
            return state.dingTalkUrl + "/sns_authorize?appid=" + state.appId + "&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=" + getters.getGoto + "&loginTmpCode=";
        }
    }
});
